'use client'

import { MouseEvent } from 'react'

import FollowButton from '@marketplace-web/user-follow/follow-button-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { followUserEvent } from '@marketplace-web/search/user-search-data'

import UserCell from './UserCell'

type Props = {
  users: Array<{
    id: number
    login: string
    businessAccount?: unknown | null
    feedbackReputation: number
    feedbackCount: number
    isBusiness: boolean
    photo: { url: string; thumbnails: Array<{ type: string; url: string }> } | null
    isFavourite: boolean
  }>
  showFollowButtons?: boolean
  showBusinessBadges?: boolean
  testId?: string
}

const calculateRating = (reputation: number): number => {
  return Math.round(reputation * 5 * 100) / 100
}

const UserGrid = ({
  users,
  showBusinessBadges = false,
  showFollowButtons = false,
  testId,
}: Props) => {
  const { track } = useTracking()

  const handleFavouriteToggle =
    (userId: number) =>
    ({ isFollowEvent }: { isFollowEvent: boolean }, event: MouseEvent) => {
      event.stopPropagation()
      event.preventDefault()
      track(followUserEvent({ userId, isFollowEvent }))
    }
  const renderFollowButton = (userId: number, isFavourite: boolean) => {
    if (!showFollowButtons) return null

    return (
      <FollowButton
        userId={userId}
        isActive={isFavourite}
        size="medium"
        onFollowToggle={handleFavouriteToggle(userId)}
        inline
        testId={testId ? `${testId}-item-follow-button` : testId}
      />
    )
  }

  return (
    <div className="user-grid wide">
      {users.map(user => {
        const { id, login, businessAccount, feedbackReputation, isBusiness, photo, isFavourite } =
          user

        return (
          <div key={id} className="user-grid__item">
            <UserCell
              login={login}
              businessAccountName={
                typeof businessAccount === 'object' &&
                businessAccount &&
                'name' in businessAccount &&
                typeof businessAccount.name === 'string'
                  ? businessAccount.name
                  : undefined
              }
              photoUrl={photo?.url}
              id={id}
              averageRating={calculateRating(feedbackReputation)}
              ratingCount={user.feedbackCount}
              isBusiness={showBusinessBadges && isBusiness}
              testId={testId ? `${testId}-item` : testId}
            />
            {renderFollowButton(id, isFavourite)}
          </div>
        )
      })}
    </div>
  )
}

export default UserGrid
